module.exports = __webpack_public_path__ + "img/7a1e6a3fcbdcb644a897ecb1b985edda-enable_2fa_4.png";